import React, { Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";

import routesTemplates from "./index";
import PublicLayout from "../templates/layouts/public/Layout";
import PageNotFound from "../views/errors/PageNotFound";
import { createMemoryHistory } from "history";
import { ROUTE_TYPES } from "./routeTypes";

import Auth from "./Auth";
import PrivateAuthGuard from "./PrivateAuthGuard";
import PrivateLayoutShell from "../templates/layouts/private/PrivateLayoutShell";
import PrivatePage from "./PrivatePage";
import Spinner from "../components/Spinner";

const AppRoutes = () => {
  const history = createMemoryHistory();

  return (
    <Suspense fallback={<Spinner />}>
      <BrowserRouter location={history.location} navigator={history}>
        <Routes>
          <Route
            path="*"
            element={<PublicLayout Component={PageNotFound} route={true} />}
          />
          {routesTemplates.map((routesTemplate) => {
            const { routes: appRoutes, template: Template, type } = routesTemplate;

            if (type === ROUTE_TYPES.private) {
              return (
                <Route key="private-routes" element={<PrivateAuthGuard />}>
                  <Route element={<PrivateLayoutShell />}>
                    {appRoutes.map((appRoute) => (
                      <Route
                        key={appRoute.path}
                        path={appRoute.path}
                        element={<PrivatePage appRoute={appRoute} />}
                      />
                    ))}
                  </Route>
                </Route>
              );
            }

            return appRoutes.map((appRoute) => (
              <Route
                path={appRoute.path}
                key={appRoute.path}
                element={
                  <Auth
                    appRoute={appRoute}
                    Template={Template}
                    route={appRoute.path}
                    type={type}
                  />
                }
              />
            ));
          })}
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
};

export default AppRoutes;
